import { authorized } from './request'

// Pulse Intelligence (FNB) campaigns live on admin-website-backend behind bearer
// auth, which `authorized` supplies; the list endpoint omits posts, so the full
// record is loaded on selection.

const fetchBrandCampaigns = ownerId =>
  authorized(`/campaigns?ownerId=${ownerId}`).then(response => response.json())

const fetchCampaign = campaignId =>
  authorized(`/campaigns/${campaignId}`).then(response => response.json())

export default { fetchBrandCampaigns, fetchCampaign }



// WEBPACK FOOTER //
// ./src/services/campaigns.js